// Replacement for react-video-tag (unmaintained, no React 19 peer range).
// React sets `muted` only as a DOM property, never as an HTML attribute, and
// iOS Safari won't autoplay inline video without the attribute — so, like the
// library, render the <video> as markup. Differences from the library: values
// are HTML-escaped, and `poster` carries its URL (the library emitted a bare
// `poster` attribute, so the poster never showed).
type Flag = boolean | string | undefined;

interface VideoTagProps {
  src?: string;
  type?: string;
  poster?: string;
  className?: string;
  autoPlay?: Flag;
  muted?: Flag;
  playsInline?: Flag;
  loop?: Flag;
  controls?: Flag;
}

const escapeAttr = (value: string) =>
  value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

export function videoTagString({ src, type, poster, className, autoPlay, muted, playsInline, loop, controls }: VideoTagProps = {}) {
  const attrs = [
    className ? ` class="${escapeAttr(className)}"` : "",
    muted ? " muted" : "",
    autoPlay ? " autoplay" : "",
    playsInline ? " playsinline" : "",
    loop ? " loop" : "",
    controls ? " controls" : "",
    poster ? ` poster="${escapeAttr(poster)}"` : "",
  ].join("");
  const typeAttr = type ? ` type="${escapeAttr(type)}"` : "";
  return `<video${attrs}><source src="${escapeAttr(src || "")}"${typeAttr}></video>`;
}

export function VideoTag(props: VideoTagProps) {
  return <span dangerouslySetInnerHTML={{ __html: videoTagString(props) }} />;
}
